import { render } from "./InterfaceUpgrading.vue?vue&type=template&id=d13b79b8&scoped=true"
import script from "./InterfaceUpgrading.vue?vue&type=script&lang=js"
export * from "./InterfaceUpgrading.vue?vue&type=script&lang=js"

import "./InterfaceUpgrading.vue?vue&type=style&index=0&id=d13b79b8&scoped=true&lang=scss"

import exportComponent from "/tmp/bc49b04f-2ffc-492f-a3c6-ed004d6cdf93/frontend/core/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d13b79b8"]])

export default __exports__